export enum EducationalAttachmentStatus {
    Active = 'Active',
    InActive = 'InActive',
}
